<script>
import { compile, h } from 'vue'
export default {
    name: 'vue-raw',
    props: {
        raw: HTMLElement | String,
        tag: {
            type: String,
            default: 'div'
        }
    },
    render () {
        const div = document.createElement(this.tag)
        div.innerHTML = this.raw
        return h(compile(div.outerHTML.replace(/\s{2,}/g, '')))
    }
}
</script>
